import React from 'react';

import { makeStyles } from '@material-ui/core';

import ResourceItem from './ResourceItem';

const useStyles = makeStyles(() => {
  return {
    container: {
      display: 'grid',
      gridGap: '50px 30px',
      gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
      overflow: 'auto',
    },
  };
});
const ResourcesList = ({
  materials,
  onEditMaterial,
  onDeleteMaterial,
  onViewMaterial,
  selectedMaterialIds,
  loadingResourceInfo,
  onSelectMaterial,
  isSelectable,
  disableEditButton,
  disableDeleteButton,
  isTechQA,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {materials.map((material) => (
        <ResourceItem
          disableEditButton={disableEditButton}
          disableDeleteButton={disableDeleteButton}
          isSelectable={isSelectable}
          material={material}
          key={material.id}
          isSelected={(selectedMaterialIds || []).includes(material.id)}
          loading={material.resource.uuid === loadingResourceInfo}
          onEditMaterial={() => onEditMaterial(material)}
          onDeleteMaterial={() => onDeleteMaterial(material)}
          onViewMaterial={() => onViewMaterial(material)}
          onSelectMaterial={() => onSelectMaterial(material)}
          isTechQA={isTechQA}
          privacy={material.privacy}
        />
      ))}
    </div>
  );
};

export default ResourcesList;
